<template>
    <div class="underlay" @mousedown="underlayClick">
        <div class="sidebar_votes">
            <div class="close" @click="onCloseClick">
                <img src="@/assets/icons/ic_close_white.svg" alt="Close">
            </div>
            <div class="title">
                {{ translate('ownLastVotes') }}
            </div>
            <div class="content">
                <div class="progress-wrapper" v-if="loading">
                    <md-progress-spinner id="progressbar" :md-diameter="60"
                                         md-mode="indeterminate" class="mapProgressVotes"></md-progress-spinner>
                </div>
                <div class="not_found" v-if="items.length == 0 && !loading">
                    {{translate('own_votesNotFound')}}
                </div>
                <div v-if="limitedAccess.show" class="limited_access"
                     v-html="translate('own_limitedAccessText', [limitedAccess.totalCount, `<a href='mailto:team@air-vote.com?subject=Limited access' style='color:#245bc4; text-decoration:underline;'>team@air-vote.com</a>`])"></div>
                <ul v-if="items.length > 0">
                    <li
                            v-for="(item, index) in items"
                            :key="item.itemId"
                            :rate="item.rate"
                            v-if="index < itemsShow">
                        <span class="date">{{ item.date | moment("MMM D YYYY, h:mm a") }}</span>
                        <div class="vote_info_item">{{translate('own_votesQuestion')}} <span>{{ item.question }}</span></div>
                        <div class="vote_info_item">{{translate('own_votesPlacement')}} <span>{{ item.extended_placement }}</span></div>
                        <div class="vote_info_item">{{translate('own_votesPriorVotes')}} <span>{{ item.prior_votes }}</span></div>
                        <div class="vote_info_item" v-if="item.comment">{{translate('own_votesComment')}} <span>{{ item.comment }}</span></div>
                        <div class="vote_info_item" v-if="item.contact_info">{{translate('own_votesContactInfo')}} <span>{{ item.contact_info }}</span></div>
                        <div class="vote_info_item" v-if="item.user">{{translate('own_votesUser')}} <span>{{ item.user.name }} (<a
                                :href="'mailto:' + item.user.email">{{ item.user.email }}</a>)</span></div>

                        <div class="attachments" v-if="item.attachments.images.length > 0">
                            <img v-for="(item, index) in item.attachments.images"
                                 :key="index"
                                 :src="item.previewUrl"
                                 @click="onVoteImageClick(item)"/>
                        </div>
                    </li>
                </ul>
                <div class="showMore__btn-wrapper">
                    <b-button @click="showMoreForItem(items)"  class="showMore__btn"
                              v-if="showMoreButton">{{translate('own_showMore')}}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {mapActions, mapState} from "vuex";
import errorMixin from '@/mixins/errorMixin';
import $ from 'jquery'
import config from "@/api/config";


export default {
    name: 'comments',

    data() {
        return {
            items: [],
            sites_count: 0,
            loading: true,
            itemsShowCount: 20,
            showMoreButton: false,
            itemsShow: null,
            limitedAccess: {
                show: false,
                totalCount: 0,
            },
        }
    },

    mixins: [errorMixin],

    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {

                }
            }
        },
    },


    async mounted() {
        await this.fetchLastVotes()
    },

    watch: {
        comments() {
            this.fetchLastVotes()
        }
    },

    computed: {
        ...mapState({
            showReportByChosen: state => state.owner.showReportByChosen,
            analyticTimeFilter: state => state.owner.analyticTimeFilter,
            customDate: state => state.owner.customDate,
            userInfo: state => state.auth.userInfo,
        })
    },

    methods: {

        ...mapActions({
            fetchLastVotesAction: 'owner/fetchLastVotes'
        }),

        async fetchLastVotes() {
            this.loading = true
            try {
                let body = {}
                const response = await this.fetchLastVotesAction({body})
                this.sites_count = response.sites_count
                for (var i = 0; response.votes.length > i; i++) {
                    let item = response.votes[i]
                    item.extended_placement = this.getExtendedPlacement(item)
                }
                this.items = response.votes
                this.applyLoadMoreSettingsButton()
                if(response.limited_votes && response.limited_votes.total_count > 0) {
                    this.limitedAccess.show = true
                    this.limitedAccess.totalCount = response.limited_votes.total_count
                }
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loading = false
            }
        },

        getExtendedPlacement(vote) {
            let show_w3w = this.userInfo.setups.views.show_w3w && vote.location
            let arr = []
            if(this.sites_count > 1) arr.push(vote.place_name)
            if(vote.placement) arr.push(vote.placement)
            if(vote.asset_id) arr.push(vote.asset_id)
            if(show_w3w) arr.push(vote.location.w3w)
            return arr.join(' | ')
        },

        onVoteImageClick(item) {
            window.open(item.originUrl, '_blank')
        },
        underlayClick(e) {
            if (($(".underlay").has(e.target).length === 0)) {
                this.onCancelAction()
            }
        },
        onCloseClick() {
            this.settings.closeHandler()
        },
        applyLoadMoreSettingsButton() {
            this.itemsShow = this.items.length > this.itemsShowCount ? this.itemsShowCount : this.items.length
            this.showMoreButton = this.items.length > this.itemsShow
        },
        showMoreForItem() {
            this.showMoreButton = false
            let diff = this.items.length - this.itemsShow
            diff = diff > this.itemsShowCount ? this.itemsShowCount : diff
            this.itemsShow += diff
            this.showMoreButton = this.items.length > this.itemsShow
        }

    }
}

</script>

<style>
.mapProgressVotes svg {
    stroke: black !important;
    width: 40px !important;
    height: 40px !important;
}
</style>
<style scoped>

.progress-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.title {
    color: #2F2F2F;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 20px;
    font-weight: 700;
}
.not_found {
    white-space: pre-line;
    font-weight: 500;
}
.limited_access {
    white-space: pre-line;
    font-weight: 500;
    color: #a30000;
}
.close {
    position: relative !important;
    top: -6px !important;
    cursor: pointer !important;
}

.grid {
    display: grid;
    grid-template-columns: max-content auto;
    align-content: center;
    color: #2F2F2F;
    grid-gap: 8px;
}

.grid * {
    display: flex;
    align-content: center;
}

.grid label {
    font-weight: 500;
    font-size: 14px;
    /*line-height: 22px;*/
    margin-right: 16px;
    margin-bottom: 0;
}

.grid .sub {
    font-weight: 300;
    font-size: 14px;
    /*line-height: 17px;*/
}

.content ul {
    margin-top: 15px;
}

.content li {
    padding: 10px 16px;
    width: 100%;
    margin: 0 0 8px 0;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    background: #F7F7F7;
}

.content li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
}

.content li[rate="3"]:before {
    background-color: #36BC00
}

.content li[rate="2"]:before {
    background-color: #FEB000
}

.content li[rate="1"]:before {
    background-color: #EF4200
}

.content li .date {
    color: #6D6D6D;
    font-size: 13px;
    line-height: 18px;
    font-weight: 300;
    margin-bottom: 3px;
}

.content li p {
    margin: 0;
    font-size: 14px;
    color: #2F2F2F;
}

.content li .placement {
    color: #6D6D6D;
    font-size: 13px;
    line-height: 18px;
    font-weight: 300;
    padding-bottom: 5px;
    padding-right: 10px;
    width: 100%;
    word-break: break-all;
}

.attachments {
    margin-top: 4px;
    height: 50px;
    overflow: scroll;
    display: flex;
}

.attachments img {
    max-width: 100%;
    max-height: 50px;
    cursor: pointer;
    margin-right: 4px;
}

.vote_info_item {
    font-size: 14px;
}

.vote_info_item span {
    font-weight: 500;
}

.vote_info_item span a {
    font-weight: 500;
    color: #2F2F2F;
    text-decoration: underline;
}
.sidebar_votes {
    height: 100vh;
    overflow-x: hidden;
    background: #fff;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 700px;
    max-width: 100%;
    padding: 25px;
    z-index: 9999;
}
.showMore__btn-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
}
.showMore__btn {
    background-color: #3F405C;
    padding: 12px 54px;
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    border-radius: 6px;
    cursor: pointer;
    width: auto;
}

</style>